import { render, staticRenderFns } from "./expression.vue?vue&type=template&id=1324f0b5&"
import script from "./expression.vue?vue&type=script&lang=js&"
export * from "./expression.vue?vue&type=script&lang=js&"
import style0 from "./expression.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports